import { render, staticRenderFns } from "./OldRegGhardhaniList.vue?vue&type=template&id=6b906a64&scoped=true&"
import script from "./OldRegGhardhaniList.vue?vue&type=script&lang=js&"
export * from "./OldRegGhardhaniList.vue?vue&type=script&lang=js&"
import style0 from "./OldRegGhardhaniList.vue?vue&type=style&index=0&id=6b906a64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b906a64",
  null
  
)

export default component.exports